/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineIncludedRoomStayServiceDto
 */
export interface TravelineIncludedRoomStayServiceDto {
    /**
     * Service identifier
     * @type {string}
     * @memberof TravelineIncludedRoomStayServiceDto
     */
    id: string;
    /**
     * Meal plan code if applicable
     * @type {string}
     * @memberof TravelineIncludedRoomStayServiceDto
     */
    mealPlanCode?: string | null;
}

/**
 * Check if a given object implements the TravelineIncludedRoomStayServiceDto interface.
 */
export function instanceOfTravelineIncludedRoomStayServiceDto(value: object): value is TravelineIncludedRoomStayServiceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineIncludedRoomStayServiceDtoFromJSON(json: any): TravelineIncludedRoomStayServiceDto {
    return TravelineIncludedRoomStayServiceDtoFromJSONTyped(json, false);
}

export function TravelineIncludedRoomStayServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineIncludedRoomStayServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mealPlanCode': json['mealPlanCode'] == null ? undefined : json['mealPlanCode'],
    };
}

  export function TravelineIncludedRoomStayServiceDtoToJSON(json: any): TravelineIncludedRoomStayServiceDto {
      return TravelineIncludedRoomStayServiceDtoToJSONTyped(json, false);
  }

  export function TravelineIncludedRoomStayServiceDtoToJSONTyped(value?: TravelineIncludedRoomStayServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mealPlanCode': value['mealPlanCode'],
    };
}

